import { StudentActionType, StudentInitialState } from "../interfaces/interfaces";
import { StudentType } from "../interfaces/actionTypes";

const authInitialState: StudentInitialState = {
  loading: false,
  error: null,
  data: {
    user_id: "",
    username: "",
    fullname: "",
    role: "",
    email: "",
    token: "",
    expiresIn: "",
    message: "",
    success: false
  },
  courses: { "courses": [] },
  registeredCourses: {
    success: false,
    registered_courses: [{
      course_description: "",
      course_id: "",
      course_name: "",
      lecture_days: "",
      lecture_hours: "",
      student_id: "",
      student_username: ""
    }]
  }, lessons: {
    success: false,
    lessons: [{
      course_id: "",
      course_name: "",
      course_description: "",
      teacher_username: "",
      video_id: "",
      video_name: "",
      video_link: "",
      video_description: "",
      student_id: ""
    }]
  }, assignments: {
    success: false,
    assignments: [{
      course_id: "",
      course_name: "",
      course_description: "",
      teacher_username: "",
      assignment_id: "",
      assignment_grade: 0,
      assignment_link: "",
      assignment_due_date: "",
      student_id: ""
    }]
  }, notes: {
    success: false,
    notes: [{
      course_id: "",
      course_name: "",
      course_description: "",
      teacher_username: "",
      file_id: "",
      file_name: "",
      file_link: "",
      file_description: "",
      student_id: ""
    }]
  },
  submittedAssignments: [{
    "assignment_id": "",
    "assignment_grade": 0,
    "assignment_link": "",
    "assignment_score": null,
    "assignment_due_date": "",
    "teacher_id": "",
    "course_id": "",
    "course_name": "",
    "student_id": "",
    "teacher_username": "",
    "teacher_fullname": "",
    "student_fullname": "",
    "student_username": ""
  }],
  registrationStatus: {},
  emailSent: false
}
// change-password, update-profile, forgot-password, email sent
export default function studentReducer(state: StudentInitialState = authInitialState, action: StudentActionType): StudentInitialState {
  switch (action.type) {
    case StudentType.LOGIN:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
        emailSent: false
      }
    case StudentType.REGISTER:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
        emailSent: false
      }
    case StudentType.LOGOUT:
      localStorage.removeItem("vidcom");
      return {
        ...state,
        loading: false,
        data: {
          user_id: "",
          username: "",
          fullname: "",
          role: "",
          email: "",
          token: "",
          expiresIn: "",
          message: "",
          success: false
        },
        error: null,
        emailSent: false
      }
    case StudentType.AUTH_ERROR:
      console.log(action.payload)
      return {
        ...state,
        loading: false,
        data: {
          user_id: "",
          username: "",
          fullname: "",
          role: "",
          email: "",
          token: "",
          expiresIn: "",
          message: "",
          success: false
        },
        error: action.payload,
        emailSent: false
      }
    case StudentType.GET_COURSES:
      return {
        ...state,
        loading: false,
        courses: action.payload,
        emailSent: false
      }
    case StudentType.REGISTER_COURSES:
      return {
        ...state,
        loading: false,
        emailSent: false,
        registrationStatus: action.payload
      }
    case StudentType.REGISTERED_COURSES:
      return {
        ...state,
        registeredCourses: action.payload,
        loading: false,
        emailSent: false,
        error: null,
      }
    case StudentType.GET_ASSIGNMENTS:
      return {
        ...state,
        loading: false,
        assignments: action.payload,
        error: null,
        emailSent: false
      }
    case StudentType.GET_SUBMITTED_ASSIGNMENTS:
      return {
        ...state,
        loading: false,
        submittedAssignments: action.payload,
        error: null,
        emailSent: false
      }
    case StudentType.GET_NOTES:
      return {
        ...state,
        loading: false,
        notes: action.payload,
        error: null,
        emailSent: false
      }
    case StudentType.GET_LESSONS: {
      return {
        ...state,
        loading: false,
        lessons: action.payload,
        error: null,
        emailSent: false
      }
    }
    case StudentType.LOADING:
      return {
        ...state,
        loading: true
      }
    default:
      return state;
  }
}